module.exports = __webpack_public_path__ + "static/organizational-influence-processes-7d70e12b632eb9b07d1cdc68e3944213.jpg";